import React, { useRef, memo } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
export function FinalCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  const {
    t,
    lang
  } = useLanguage();
  return <section ref={ref} className="relative h-[65vh] min-h-[500px] lg:h-[80vh] overflow-hidden w-full" data-id="element-116">
      <motion.div style={{
      y
    }} className="absolute inset-0 -top-[10%] -bottom-[10%]" data-id="element-117">
        <img src="https://cdn.magicpatterns.com/uploads/2ok3qK9AJ1jNpYFRysFyxM/ChatGPT_Image_May_27,_2026_at_04_00_02_PM.png" alt="Picnic al atardecer frente al océano en Tenerife" className="w-full h-full object-cover" data-id="element-118" />
      </motion.div>

      <div className="absolute inset-0 bg-volcanic/50" data-id="element-119" />
      <div className="absolute inset-0 bg-gradient-to-t from-volcanic/80 via-transparent to-transparent" data-id="element-120" />

      <div className="relative h-full flex flex-col items-center justify-center text-center text-ivory px-5 sm:px-8" data-id="element-121">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] lg:text-xs font-semibold mb-6 sm:mb-10" data-id="element-122">
          {t('finalCta.tag')}
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.4,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-display text-fluid-h2 font-light leading-[1.1] max-w-4xl mb-4" data-id="element-123">
          {t('finalCta.title1')} <br data-id="element-124" />
          <span className="font-script text-fluid-script-hero text-terracotta inline-block mt-[-0.1em]" data-id="element-125">
            {t('finalCta.title2')}
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        delay: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-6 sm:mt-8 max-w-xl text-ivory/85 text-[13px] sm:text-base leading-relaxed font-light" data-id="element-126">
          {t('finalCta.desc')}
        </motion.p>

        <motion.a initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        delay: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} href={whatsappLink('finalCta', lang)} target="_blank" rel="noopener noreferrer" className="mt-8 sm:mt-12 bg-terracotta hover:bg-terracottaDark text-ivory px-10 sm:px-14 py-4 sm:py-5 rounded-md uppercase tracking-[0.2em] text-[10px] sm:text-xs transition-colors duration-300 w-full sm:w-auto" data-id="element-127">
          {t('finalCta.btn')}
        </motion.a>
      </div>
    </section>;
}